// client/src/App.js (FINAL ROUTER VERSION)

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import all your components
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import OurWork from './components/OurWork/OurWork';
import AboutUs from './components/AboutUs/AboutUs';
import EnquiryForm from './components/EnquiryForm/EnquiryForm';
import RegistrationBanner from './components/RegistrationBanner/RegistrationBanner';
import Registration from './components/Registration/Registration';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import ContactUs from './components/ContactUs/ContactUs';

// --- 1. Create a component for your main homepage ---
// This component just groups all your main sections together
const HomePage = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <Services />
      <OurWork />
      <AboutUs />
      <EnquiryForm />
      <RegistrationBanner />
      <ContactUs />
    </>
  );
};

// --- 2. This is your main App component ---
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Route 1: The Homepage */}
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<Registration />} />

          {/* Route 2: The Admin Dashboard */}
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;